import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Modal as BaseModal } from '@/components/Modal';

export const ModalBodyWrapper = styled(Box)`
  ${({ theme }) => css`
    padding: ${theme.spacing(3, 5)};
  `}
`;

export const HeaderWrapper = styled(Box)`
  ${({ theme }) => css`
    ${theme.media.md.up} {
      padding: ${theme.spacing(0, 12)};
    }
  `}
`;

export const BodyInner = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ theme }) => css`
    margin: ${theme.spacing(3, 0)};
  `}
  ${({ theme }) => css`
    ${theme.media.md.up} {
      flex-direction: row;
    }
  `}
`;

export const InfoBox = styled(Box)`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.secondaryLightGrey};
`;

export const InfoBoxHeader = styled(Box)`
  text-align: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.primaryDark};
    color: ${theme.colors.primary};
    padding: ${theme.spacing(2)};
    font-size: ${theme.fontSizes.p1};
  `}
`;
export const InfoBoxBodyMobWrapper = styled(Box)`
  height: 410px;
`;
export const InfoBoxBody = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.secondaryLightGrey};
    padding: ${theme.spacing(4, 4)};
  `}
`;

export const ButtonGroup = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 260px;
  margin: auto;
  gap: 16px;
  ${({ theme }) => css`
    padding: ${theme.spacing(2, 0)};
  `}
  ${({ theme }) => css`
    ${theme.media.md.up} {
      padding: ${theme.spacing(0, 0)};
    }
  `}
`;

export const LearnMore = styled(Box)`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
`;

export const InfoBoxHeaderMobContainer = styled(Flex)`
  width: 100%;
`;

export const InfoBoxHeaderTab = styled(Box)<{ $isActive: boolean }>`
  text-align: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(2)};
  font-size: ${({ theme }) => theme.fontSizes.p1};
  color: ${({ theme }) => theme.colors.charcoalGray};
  background-color: ${({ theme }) => theme.colors.primaryAdd6};
  ${({ $isActive, theme }) =>
    $isActive &&
    css`
      background-color: ${theme.colors.primaryDark};
      border-bottom: 2px solid ${theme.colors.primaryDark};
      color: ${theme.colors.primary};
    `}
`;

export const Modal = styled(BaseModal)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    padding-block: ${theme.spacing(2, 0)};
    ${theme.media.sm.up} {
      display: block;
      flex-direction: unset;
      height: fit-content;
      padding-block: ${theme.spacing(2, 4)};
    }
  `}
`;
export const ModalBody = styled(BaseModal.Body)`
  flex: 1;
`;
